function labelFormatter() {
  return `
    <div style="font-size: 14px; line-height: 1.2; margin-bottom: 4px; font-family: Dustin Sans; font-weight: normal">
      <div>${this.name}</div>
      <div style="color: #8D8D8D; font-size:12px; line-height: 1.2">${this.percentage.toFixed(0)}%</div>
    </div>`;
}

export default labelFormatter;
